<template>
  <div v-if="single_page" ref="card" class="col-sm-6 col-md-4 col-lg-4 px-2 mb-3 card-action" :class="'action-theme-'+action.id_theme">
    <div class="card h-100 transition-3d-hover">
      <div class="card-body pb-0">
        <div class="mb-2">
          <img class="avatar avatar-sm avatar-circle" :src="action.photo_filename" :alt="'Avatar de '+ action.author">
        </div>
        <span class="d-block font-italic mb-2">proposée par {{ action.author }}, le {{ action.created_at }}</span>
          <div class="position-absolute top-0 right-0 pt-4 pr-3">
            <div class="d-flex align-items-center">
              <a class="btn btn-xs btn-icon btn-primary rounded-circle"
                 data-toggle="tooltip" data-placement="top" title="Participez à la discussion"
                 :href="getLink(action.id)">
                <i class="fas fa-comments"></i>
              </a>
              <span class="p-2" v-text="action.nb_comments">
                0
              </span>
            </div>


          </div>
        <a :href="getLink(action.id)">
          <h4 class="text-lh-sm">
            <i class="fas fa-archive"></i>&nbsp;{{ action.title }}
          </h4>
        </a>
        <p class="font-size-1" v-text="action.description"></p>
      </div>
      <!-- end Body -->

      <div class="card-footer border-0 pt-0">
        <div class="row d-flex align-items-center">
          <div class="col-9 text-right">
            <button v-if="action.liked == 1" class="btn btn-sm btn-danger w-100" type="button" @click="dislike()">
              <i class="fa fa-thumbs-down fa-lg" aria-hidden="true"></i>
              &nbsp;Je n'aime plus
            </button>
            <button v-else class="btn btn-sm btn-primary w-100" type="button" @click="like()">
              <i class="fa fa-thumbs-up fa-lg" aria-hidden="true"></i>
              &nbsp;J'aime
            </button>
          </div>
          <div class="col-3">
            <div class="row">
              <div class="col-6 text-right pr-0">
                <span v-text="action.total_votes"></span>
              </div>
              <div class="col-6 text-left">
                <i class="fa fa-thumbs-up" aria-hidden="true"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else ref="card" class="col-sm-6 col-md-6 mb-3 card-action" :class="'action-theme-'+action.id_theme">
    <div class="card h-100 transition-3d-hover">
      <div class="card-body pb-0">
        <div class="mb-2">
          <img class="avatar avatar-lg avatar-circle" :src="getImgUrl(action.photo_filename)" :alt="'Avatar de '+ action.author">
        </div>
        <span class="d-block font-italic mb-2">proposée par {{ action.author }}, le {{ action.created_at }}</span>
        <div class="position-absolute top-0 right-0 pt-4 pr-3">
          <div class="d-flex align-items-center">
            <a class="btn btn-xs btn-icon btn-primary rounded-circle"
               data-toggle="tooltip" data-placement="top" title="Participez à la discussion"
               :href="getLink(action.id)">
              <i class="fas fa-comments"></i>
            </a>
            <span class="p-2" v-text="action.nb_comments">
            </span>
          </div>


        </div>
        <a :href="getLink(action.id)">
          <h4 class="text-lh-sm">
            <i class="fas fa-archive"></i>&nbsp;{{ action.title }}
          </h4>
        </a>
        <p class="font-size-1" v-text="action.description"></p>

      </div>
      <!-- end Body -->

      <div class="card-footer border-0 pt-0">
        <div class="row d-flex align-items-center">
          <div class="col-9 text-right">
            <button v-if="action.liked == 1" class="btn btn-sm btn-danger w-100" type="button" @click="dislike()">
              <i class="fa fa-thumbs-down fa-lg" aria-hidden="true"></i>
              &nbsp;Je n'aime plus
            </button>
            <button v-else class="btn btn-sm btn-primary w-100" type="button" @click="like()">
              <i class="fa fa-thumbs-up fa-lg" aria-hidden="true"></i>
              &nbsp;J'aime
            </button>
          </div>
          <div class="col-3">
            <div class="row">
              <div class="col-6 text-right pr-0">
                <span v-text="action.total_votes"></span>
              </div>
              <div class="col-6 text-left">
                <i class="fa fa-thumbs-up" aria-hidden="true"></i>
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    single_page: Boolean,
    action: Object,
    theme_id: Number,
    is_logged: Boolean,
    is_admin: Boolean,
    company: Object,
  },
  methods: {
    getImgUrl(pic) {
      return "/themes/template/img/" + pic
    },
    getLink(id) {
      return "/module/dlnkactions/action?id=" + id
    },
    like: function () {
      if(this.is_logged == false) {
        this.$emit('error', "Vous devez être connecté pour participer")
        return 0;
      }

      this.$emit('like', this.action.id)
    },
    dislike: function () {
      if(this.is_logged == false) {
        this.$emit('error', "Vous devez être connecté pour participer")
        return 0;
      }

      this.$emit('dislike', this.action.id)
    },
  }
}
</script>
